import './modules/register-service-worker';
import '@crasman/branch-bar/styles.css';
import { branchBar } from '@crasman/branch-bar';
import { initMakronNavigation } from './modules/navigation';
import { initCampaignBanner } from './modules/campaign-banner';
import { injectSvgSprite } from './modules/svg-sprite';
import { initLangSelector } from './modules/lang-selector';
import Carousel from './modules/carousel';
import { initCarousel } from './modules/logo-carousel';
import { initSectionToggles } from './modules/content-toggle';
import { initKeyMilestones } from './modules/key-milestones';
import { initReferenceGridSearch } from './modules/reference-grid-search';
import { initNewsEventsGrid } from './modules/news-events-grid';
import { initContactPeopleGrid } from './modules/contact-people-grid';
import { initCookiebotLinks } from './modules/cookiebot';

// See https://www.npmjs.com/package/@crasman/branch-bar for settings
branchBar.init();

initMakronNavigation();
initCampaignBanner();

const carouselElements = document.querySelectorAll('.carousel');

carouselElements.forEach(el => {
  new Carousel(el);
});


const logoCarouselElements = document.querySelectorAll('.logo-carousel');
logoCarouselElements.forEach(el => {
  initCarousel(el);
});

if (document.querySelector('.toggled-content-section')) {
  initSectionToggles(
    '.toggled-content-section',
    '.toggler',
    '.toggled-content-section__details'
  );
}

if (document.querySelector('.key-milestones-section')) {
  initKeyMilestones();
}

if (document.querySelector('.reference-grid-search')) {
  initReferenceGridSearch();
}

if (document.querySelector('.news-events-grid')) {
  initNewsEventsGrid();
}

if (document.querySelector('.contact-people-grid')) {
  initContactPeopleGrid();
}

// Convert CMS-generated Cookiebot links (data-href="javascript: Cookiebot.renew()")
// into safe, event-driven consent dialog triggers.
initCookiebotLinks();

initLangSelector();

// Sprite URL is read from a <meta name="sprite-url"> tag set by the CMS/template.
// Fallback: /sprite.svg (works when static files are served from root in dev).
const spriteMeta = document.querySelector('meta[name="sprite-url"]');
const spriteUrl = spriteMeta ? spriteMeta.getAttribute('content') : '/sprite.svg';
injectSvgSprite(spriteUrl);
